import { Grid } from '@mui/material';
import { useMemo } from 'react';

export interface MfaRecoveryListProps {
  otps: string[];
}

function isEven(n: number): boolean {
  return n % 2 === 0;
}

export default function MfaRecoveryList({ otps }: MfaRecoveryListProps) {
  const [evenOtps, oddOtps] = useMemo<[string[], string[]]>(
    () => (
      otps.reduce<[string[], string[]]>(
        (acc, otp, index) => {
          const [even, odd] = acc;
          return isEven(index)
            ? [[...even, otp], odd]
            : [even, [...odd, otp]];
        },
        [[], []],
      )),
    [otps],
  );

  return (
    <Grid container spacing={2} flexDirection="row" justifyContent="space-between">
      <Grid item xs={6}>
        <ul>
          {evenOtps.map((otp) => (
            <li key={otp}>{otp}</li>
          ))}
        </ul>
      </Grid>
      <Grid item xs={6}>
        <ul>
          {oddOtps.map((otp) => (
            <li key={otp}>{otp}</li>
          ))}
        </ul>
      </Grid>
    </Grid>
  );
}
